import { Users } from "lucide-react";
import type { ProductSummary } from "@jipraks/shared";
import { catalogCopy } from "@client/locales/id/catalog";

/** Product type on the left, buyer count on the right — the first line of every product card. */
export function ProductCardMeta({ product }: { product: Pick<ProductSummary, "type" | "purchaseCount"> }) {
  return (
    <div className="flex items-center justify-between gap-2">
      <span className="font-mono text-xs tracking-widest text-accent-bright uppercase">
        {catalogCopy.productTypes[product.type]}
      </span>
      {product.purchaseCount > 0 && (
        <span className="flex items-center gap-1 text-xs text-foreground-muted">
          <Users className="size-3.5" aria-hidden="true" />
          {catalogCopy.purchased(product.purchaseCount)}
        </span>
      )}
    </div>
  );
}
